import { useUserStore } from "../store/userStore";
import { ADMIN_RESELLER_ROLE_ID } from "./useIsReseller";

export function usePolicyAccess() {
  const user = useUserStore((state) => state.user);
  const userRoleId = user?.role_id || localStorage.getItem("userRoleId") || "";
  const roleName = (user?.role || localStorage.getItem("userRole") || "").toLowerCase();
  const canEditPolicy = roleName === "admin" || userRoleId === ADMIN_RESELLER_ROLE_ID;

  return {
    canEditPolicy,
    policyInputProps: {
      disabled: !canEditPolicy,
      readOnly: !canEditPolicy,
    },
  };
}

export default usePolicyAccess;
